export default __webpack_public_path__ + "static/media/upload2.4b232984.svg";